import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import config from 'helpers/config';
import utils from 'helpers/utils';
import * as updateProductResource from 'store/actions/products/resource/updateProductResource';
import apiClient from 'clients/apiClient';

function* updateProductResourceAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        // Normalize the values.
        const normalizedValues = yield utils.normalizePayload(values);

        // Build the url.
        const url = `${ config.getApiBaseUrl() }/products/${ id }/resources`;

        // PATCH the API call.
        const response = yield apiClient.patch(url, normalizedValues);

        // Success action.
        yield put(updateProductResource.updateProductResourceSuccess(payload, response));

        // Callback to component.
        yield onSuccess();
    } catch (error) {
        // Error action
        yield put(updateProductResource.updateProductResourceFailure(error));

        // Callback to component.
        yield onError(error);
    }
}

function* updateProductResourceSuccessAsync() {
    yield put(showNotification('notifications.products.resource.update.success', 'warning'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* productSagas() {
    yield [
        takeEvery('UPDATE_PRODUCT_RESOURCE', updateProductResourceAsync),
        takeEvery('UPDATE_PRODUCT_RESOURCE_FAILURE', failureMessage),
        takeEvery('UPDATE_PRODUCT_RESOURCE_SUCCESS', updateProductResourceSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/productResourceSagas.js